export default __webpack_public_path__ + "static/media/jtt_logo_n.00e7130f.svg";